import {BrowserModule} from '@angular/platform-browser';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from "@angular/forms";
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule
} from '@angular/material';
import {CdkTableModule} from '@angular/cdk/table';



import { AppComponent } from './app.component';
import { BarComponent } from './components/bar/bar.component';
import { RegisterComponent } from './components/register/register.component';
import { AuthComponent } from './components/auth/auth.component';
import { MinibaruserComponent } from './components/minibaruser/minibaruser.component';
import { GalleryComponent } from './components/content/gallery/gallery.component';
import { NewsComponent } from './components/news/news.component';
import { DevblogComponent } from './components/devblog/devblog.component';
import { NewsdetailComponent } from './components/news/newsdetail/newsdetail.component';
import { BlogitemComponent } from './components/devblog/blogitem/blogitem.component';
import { HeaderComponent } from './components/header/header.component';
import { ContentComponent } from './components/content/content.component';
import { FooterComponent } from './components/footer/footer.component';
import { SliderComponent } from './components/header/slider/slider.component';
import { ProgressComponent } from './components/progress/progress.component';
import { PMainComponent } from './components/progress/p-main/p-main.component';
import { PHomeComponent } from './components/progress/p-home/p-home.component';
import { PBatlesystemComponent } from './components/progress/p-batlesystem/p-batlesystem.component';
import { PMechanicsComponent } from './components/progress/p-mechanics/p-mechanics.component';
import { PUiComponent } from './components/progress/p-ui/p-ui.component';
import { PAnimationComponent } from './components/progress/p-animation/p-animation.component';
import { P3dComponent } from './components/progress/p-3d/p-3d.component';
import { PLvldesignComponent } from './components/progress/p-lvldesign/p-lvldesign.component';
import { PVfxComponent } from './components/progress/p-vfx/p-vfx.component';
import { PLorComponent } from './components/progress/p-lor/p-lor.component';
import { NavbarComponent } from './components/header/navbar/navbar.component';
import { HeroesComponent } from './components/heroes/heroes.component';
import { HeroDetailComponent } from './components/hero-detail/hero-detail.component';
import { FormLoginComponent } from './components/auth/form-login/form-login.component';
import { FormRegisterComponent } from './components/auth/form-register/form-register.component';


@NgModule({
  exports: [
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule
  ]
})
export class MaterialModule {}

@NgModule({
  declarations: [
    AppComponent,
    BarComponent,
    RegisterComponent,
    AuthComponent,
    MinibaruserComponent,
    GalleryComponent,
    NewsComponent,
    DevblogComponent,
    NewsdetailComponent,
    BlogitemComponent,
    HeaderComponent,
    ContentComponent,
    FooterComponent,
    SliderComponent,
    ProgressComponent,
    PMainComponent,
    PHomeComponent,
    PBatlesystemComponent,
    PMechanicsComponent,
    PUiComponent,
    PAnimationComponent,
    P3dComponent,
    PLvldesignComponent,
    PVfxComponent,
    PLorComponent,
    NavbarComponent,
    HeroesComponent,
    HeroDetailComponent,
    FormLoginComponent,
    FormRegisterComponent
  ],
  imports: [
    NgbModule.forRoot(),
    CdkTableModule,
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/app.module.ts